var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.liffSetting)?_c('div',{staticClass:"app-main-sty container-fluid",attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }